(() => {
	if (!window.WMPlugin) return;

	const forms = document.querySelectorAll('[data-wm-form]');
	if (!forms.length) return;
	let hideElements = [];
	const moneyFormat = (value) => {
		const n = Number.isFinite(value) ? value : 0;
		try {
			return new Intl.NumberFormat(undefined, {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			}).format(n);
		} catch (e) {
			return (Math.round(n * 100) / 100).toFixed(2);
		}
	};

	const setMessage = (wrapEl, type, text) => {
		const msg = wrapEl.querySelector('.wm-message.wm-ajax');
		if (!msg) return;

		msg.classList.remove('wm-success', 'wm-error');
		msg.classList.add(type === 'success' ? 'wm-success' : 'wm-error');
		msg.textContent = '';
		msg.insertAdjacentHTML('beforeend', text);
		msg.style.display = 'block';
	};

	const peopleCount = (form) => {
		const adultsEl = form.querySelector('input[name="wm_peoples"]');
		const kidsEl = form.querySelector('input[name="wm_children"]');

		let adults = adultsEl ? parseInt(adultsEl.value || '0') : 0;
		let children = kidsEl ? parseInt(kidsEl.value || '0') : 0;

		if (checkSvetskiSto(form)) {
			adults = adults + children;
			children = 0;
		}

		return { adults, children };
	};

	const itemsTotal = (form, childrenCategory, additionalServices) => {
		let totalAdult = 0;
		let totalChildren = 0;
		let totalServices = 0;
		const checks = form.querySelectorAll(
			'.wm-food-item:not(.wm-clone-element) input[type="checkbox"][name="wm_food_items[]"]:checked',
		);

		checks.forEach((cb) => {
			const parentElement = cb.parentNode;
			if (!cb.checked) {
				parentElement.classList.remove('active-food');
				return;
			}
			const itemGroup = parseInt(cb.dataset.itemGroup);
			const price = parseFloat(cb.dataset.price || '0');
			if (itemGroup !== additionalServices) {
				if (childrenCategory && parseInt(childrenCategory) == itemGroup) {
					totalChildren += Number.isFinite(price) ? price : 0;
				} else {
					totalAdult += Number.isFinite(price) ? price : 0;
				}
			} else {
				totalServices += price;
			}

			parentElement.classList.add('active-food');
		});
		return {
			totalAdult,
			totalChildren,
			totalServices,
		};
	};
	const calcChildrenPrice = (childrens, fixPrice) => {
		return childrens * fixPrice;
	};
	const recalcTotals = (form, returnData = false) => {
		const currency = form.dataset.wmCurrency || '';
		const minPP = parseFloat(form.dataset.wmMinPp || '0') || 0;
		const formDataChildren = form.dataset.wmChildrenCategory;
		const hasMenuOnly = form.closest('.wm-menu-only') || null;

		const childrenCategory = formDataChildren
			? parseFloat(formDataChildren)
			: 0;

		const pricePerChildData = form.dataset.pricePerChild;
		const pricePerChild = pricePerChildData ? parseFloat(pricePerChildData) : 0;

		const additionalServicesData = form.dataset.additionalServices;
		const additionalServices = parseInt(additionalServicesData);

		const { adults, children } = peopleCount(form);
		const { totalAdult, totalChildren, totalServices } = itemsTotal(
			form,
			childrenCategory,
			additionalServices,
		);

		let payTotal = 0;
		let persons = adults + children;

		const childrenPriceCalc =
			pricePerChild > 0
				? calcChildrenPrice(children, pricePerChild)
				: totalChildren * children;

		if (childrenCategory == null) {
			payTotal = (totalAdult + totalChildren) * persons + totalServices;
		} else {
			payTotal = totalAdult * adults + childrenPriceCalc + totalServices;
		}
		if (hasMenuOnly) {
			payTotal = totalAdult + totalChildren + totalServices;
		}

		const perPerson = adults > 0 ? (totalAdult * adults) / adults : 0;

		if (returnData) {
			return {
				payTotal,
				perPerson,
				minPP,
			};
		}
		const minEl = form.querySelectorAll('[data-wm-per-person]');
		const payEl = form.querySelectorAll('[data-wm-pay-total]');
		const noteEl = form.querySelector('[data-wm-min-note]');

		if (form.classList.contains('min-pp-error') && minPP < perPerson) {
			form.classList.remove('min-pp-error');
			document.body.classList.remove('show-error');
		}

		if (minEl)
			for (let index = 0; index < minEl.length; index++) {
				const element = minEl[index];
				element.textContent = `${moneyFormat(perPerson)} ${currency}`.trim();
			}
		if (payEl)
			for (let index = 0; index < payEl.length; index++) {
				const element = payEl[index];
				element.textContent = `${moneyFormat(payTotal)} ${currency}`.trim();
			}
	};

	const setActive = (nodes, activeNode) => {
		nodes.forEach((n) => {
			const isActive = n === activeNode;
			n.classList.toggle('is-active', isActive);
			if (n.hasAttribute('aria-selected')) {
				n.setAttribute('aria-selected', isActive ? 'true' : 'false');
			}
		});
	};

	const activateMainTab = (form, mainId) => {
		const mainTabs = Array.from(form.querySelectorAll('[data-wm-main-tab]'));
		const panels = Array.from(form.querySelectorAll('[data-wm-main-panel]'));
		const allMainDesc = Array.from(form.querySelectorAll('.main-cat-desc'));
		const searchInput = form.querySelector('.wm_search');
		let hideSearch = false;

		for (let index = 0; index < allMainDesc.length; index++) {
			const element = allMainDesc[index];

			const descID = element.dataset.mainDescId;
			if (parseInt(mainId) == parseInt(descID)) {
				element.classList.remove('hide');
				hideSearch = true;
			} else {
				element.classList.add('hide');
			}
		}
		if (hideSearch) {
			searchInput.classList.add('hide');
		} else {
			searchInput.classList.remove('hide');
		}
		const activeTab = mainTabs.find((b) => b.dataset.wmMainTab === mainId);
		if (activeTab) {
			const parent = activeTab.closest('.wm-step');
			parent.dataset.activeMainGroup = mainId;
			setActive(mainTabs, activeTab);
		}

		panels.forEach((p) =>
			p.classList.toggle('is-active', p.dataset.wmMainPanel === mainId),
		);

		// Auto activate first sub-tab inside this main panel
		const panel = panels.find((p) => p.dataset.wmMainPanel === mainId);
		const firstSub = panel ? panel.querySelector('[data-wm-sub-tab]') : null;
		if (firstSub) {
			const token = firstSub.dataset.wmSubTab;
			activateSubTab(form, token);
		}
	};

	const activateSubTab = (form, token) => {
		const [mainId] = (token || '').split(':');
		if (!mainId) return;

		const panel = form.querySelector(
			`[data-wm-main-panel="${CSS.escape(mainId)}"]`,
		);
		if (!panel) return;

		const subTabs = Array.from(panel.querySelectorAll('[data-wm-sub-tab]'));
		const subPanels = Array.from(panel.querySelectorAll('[data-wm-sub-panel]'));

		const activeSub = subTabs.find((b) => b.dataset.wmSubTab === token);
		if (activeSub) setActive(subTabs, activeSub);

		subPanels.forEach((p) =>
			p.classList.toggle('is-active', p.dataset.wmSubPanel === token),
		);
	};
	function debounce(func, wait) {
		let timeout;

		// This is the function that will be executed when the event occurs
		return function (...args) {
			const context = this;
			// Clear the previous timeout to restart the timer on each event trigger
			// Set a new timeout to call the original function after 'wait' milliseconds
			timeout = setTimeout(() => {
				clearTimeout(timeout);

				func.apply(context, args);
			}, wait);
		};
	}

	const searchFood = (e) => {
		const target = e.target;
		const form = target.closest('form');
		const value = target.value;
		const searchData = WMDATA?.search_data || {};

		for (let index = 0; index < Object.keys(searchData).length; index++) {
			const foodId = Object.keys(searchData)[index];
			const foodItem = searchData[foodId];
			const searchAttr = foodItem.search_attribute;
			if (searchAttr.indexOf(value) == -1 && !hideElements.includes(foodId)) {
				hideElements.push(foodId);
			} else if (
				searchAttr.indexOf(value) > -1 &&
				hideElements.includes(foodId)
			) {
				hideElements = hideElements.filter((item) => item !== foodId);
			}
		}
		hideDomElements(form);
	};

	const debouncedHandler = debounce(searchFood, 400);

	const hideDomElements = (form) => {
		const hideItemClass = 'hide';
		const items = form.querySelectorAll('.wm-food-item');
		for (let index = 0; index < items.length; index++) {
			const element = items[index];
			if (
				element.dataset.item &&
				hideElements.includes(element.dataset.item + '')
			) {
				element.classList.add(hideItemClass);
			} else {
				element.classList.remove(hideItemClass);
			}
		}
	};
	const removeStepsClass = (form) => {
		const allSteps = form.querySelectorAll('.wm-step');
		for (let index = 0; index < allSteps.length; index++) {
			const step = allSteps[index];
			const stepNumber = parseInt(step.dataset.wmStep);
			document.body.classList.remove(`wm-step-${stepNumber}-active`);
		}
	};
	const checkSvetskiSto = (form) => {
		return form.dataset.menutype === 'svedski_sto'
			? form.dataset.svedskistoid
			: false;
	};
	const resetForm = (form) => {
		form
			.querySelectorAll('input[type="checkbox"], input[type="radio"]')
			.forEach((el) => (el.checked = false));
		form.querySelectorAll('.wm-clone-element').forEach((el) => el.remove());
		form
			.querySelectorAll('.have-items')
			.forEach((el) => el.classList.remove('have-items'));

		recalcTotals(form);
	};
	forms.forEach((form) => {
		const wrap = form.closest('.wm-form-wrap') || document;
		const hasMenuOnly = form.closest('.wm-menu-only') || null;

		const formMode = form.dataset.wmFormMode || 'normal';
		if (hasMenuOnly) {
			document.body.classList.add(`wm-only-menu`);
		}
		const showStep = (n) => {
			const steps = Array.from(form.querySelectorAll('[data-wm-step]'));
			if (!steps.length) return;
			document.body.classList.add(`wm-step-${n}-active`);
			steps.forEach((el) => {
				el.classList.toggle('is-active', el.dataset.wmStep === String(n));
				if (el.classList.contains('is-active')) {
					removeValidationMessages(el);
				} else {
				}
			});
		};
		const bindChangeInput = (event) => {
			const field = event.target;
			const parentElement = field.parentElement;
			if (parentElement.classList.contains('form-error-wrapper')) {
				field.classList.remove('form-error');
				parentElement.classList.remove('form-error-wrapper');
			}
		};
		const removeValidationMessages = (stepEl, removeEvents = false) => {
			if (!stepEl) return;
			const required = Array.from(stepEl.querySelectorAll('[required]'));
			const peoples = stepEl.querySelector('[name="wm_peoples"]');
			const children = stepEl.querySelector('[name="wm_children"]');
			[...required, peoples, children].forEach((field) => {
				if (field) {
					if (!removeEvents) {
						field.addEventListener('input', bindChangeInput);
					} else {
						field.removeEventListener('input', bindChangeInput);
					}
				}
			});
		};
		const validateEmail = (email) => {
			const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
			return emailPattern.test(email);
		};
		const validateStep = (n) => {
			if (hasMenuOnly) return true;
			const stepEl = form.querySelector('[data-wm-step="' + String(n) + '"]');
			if (!stepEl) return true;
			const maxPersons = form.dataset.maxPersons;
			const required = Array.from(stepEl.querySelectorAll('[required]'));
			const peoples = stepEl.querySelector('[name="wm_peoples"]');
			const email = stepEl.querySelector('[name="wm_email"]');
			const children = stepEl.querySelector('[name="wm_children"]');
			const maxPeoplesArr = [];
			let choosedPeoples = 0;

			if (peoples && children) {
				maxPeoplesArr.push(peoples);
				maxPeoplesArr.push(children);

				for (const el of maxPeoplesArr) {
					const parentElement = el.parentElement;
					el.classList.remove('form-error');
					parentElement.classList.remove('form-error-wrapper');
				}
				choosedPeoples = parseInt(peoples.value) + parseInt(children.value);
			}

			let errorsField = [];
			for (const el of required) {
				const parentElement = el.parentElement;

				el.classList.remove('form-error');
				parentElement.classList.remove('form-error-wrapper');
				const tag = (el.tagName || '').toLowerCase();
				if (tag === 'input' || tag === 'select' || tag === 'textarea') {
					if (!String(el.value || '').trim()) {
						errorsField.push(el);
						el.classList.add('form-error');
						parentElement.classList.add('form-error-wrapper');
					}
				}
			}
			if (email && !validateEmail(email.value)) {
				email.classList.add('form-error');
				email.parentElement.classList.add('form-error-wrapper');
				errorsField.push(email);
			}
			if (
				parseInt(maxPersons) < parseInt(choosedPeoples) ||
				choosedPeoples == 0
			) {
				for (const el of maxPeoplesArr) {
					const parentElement = el.parentElement;
					el.classList.add('form-error');
					parentElement.classList.add('form-error-wrapper');
					errorsField.push(el);
				}
			}
			if (errorsField.length > 0) return false;

			return true;
		};

		if (formMode === 'step') {
			showStep(1);
		}
		const searchInput = form.querySelector('#wm_search');
		if (searchInput) {
			searchInput.addEventListener('input', debouncedHandler);
		}

		// Tabs click handling (scoped per-form)
		form.addEventListener('click', (e) => {
			const openPopup = e.target.closest('.wm-food-item.active');
			const openPopupClose = e.target.closest('.short-text-popup--close');

			if (
				e.target.classList.contains('short-text-popup--trigger') ||
				e.target.classList.contains('short-text-popup') ||
				openPopup || openPopupClose
			) {
				e.preventDefault();
			}

			const nextBtn = e.target.closest('.wm-next');

			if (nextBtn) {
				const recalcData = recalcTotals(form, true);
				const closestParent = nextBtn.closest('.wm-step');
				const currentStep = parseInt(closestParent.dataset.wmStep);

				if (nextBtn && form.contains(nextBtn)) {
					if (!validateStep(1)) {
						setMessage(
							wrap,
							'error',
							window.WMPlugin.i18n && window.WMPlugin.i18n.required
								? window.WMPlugin.i18n.required
								: 'Popunite sva obavezna polja.',
						);
						return;
					}
					if (currentStep == 2 && recalcData?.minPP > recalcData?.perPerson) {
						form.classList.add('min-pp-error');
						document.body.classList.add('show-error');

						return;
					}
					removeStepsClass(form);
					showStep(currentStep + 1);
					recalcTotals(form);
					if (nextBtn.dataset.type) {
						form.dataset.menutype = nextBtn.dataset.type;
						const menuType = checkSvetskiSto(form);
						if (menuType) {
							const mainTab = form.querySelector(
								`[data-wm-main-tab="${menuType}"]`,
							);
							if (mainTab) {
								mainTab.click();
							}
						} else {
							const mainTabBanket = form.querySelector(`[data-wm-main-tab]`);
							mainTabBanket.click();
						}
						resetForm(form);
					}
					return;
				}
			}

			const backBtn = e.target.closest('.wm-back');
			if (backBtn) {
				const closestParent = backBtn.closest('.wm-step');
				const currentStep = parseInt(closestParent.dataset.wmStep);
				if (backBtn && form.contains(backBtn)) {
					removeStepsClass(form);
					showStep(currentStep - 1);
					return;
				}
				recalcTotals(form);
			}

			const mainBtn = e.target.closest('[data-wm-main-tab]');
			if (mainBtn && form.contains(mainBtn)) {
				activateMainTab(form, mainBtn.dataset.wmMainTab);
				return;
			}

			const subBtn = e.target.closest('[data-wm-sub-tab]');
			if (subBtn && form.contains(subBtn)) {
				activateSubTab(form, subBtn.dataset.wmSubTab);
			}
		});
		const toogleElementToOverview = (form, inputElement) => {
			if (inputElement) {
				const groupId = inputElement.dataset.itemGroup;
				const itemId = inputElement.value;
				const mainWrapper = form.querySelector(`#overview-group-${groupId}`);
				const elementWrapper = mainWrapper.querySelector(
					`.overview-group-items`,
				);
				const findElement = elementWrapper.querySelector(
					`[data-item="${itemId}"].wm-clone-element`,
				);
				if (findElement) {
					elementWrapper.removeChild(findElement);
					return;
				}

				const element = inputElement.closest('.wm-food-item');
				const clonedElement = element.cloneNode(true);

				clonedElement.classList.add('wm-clone-element');
				elementWrapper.appendChild(clonedElement);

				const allItems = form.querySelectorAll(
					`#overview-group-${groupId} .wm-food-item`,
				);

				if (allItems && allItems.length > 0)
					mainWrapper.classList.add('have-items');
				else mainWrapper.classList.remove('have-items');
			}
		};

		// Live recalc
		form.addEventListener('change', (e) => {
			const t = e.target;

			if (!t) return;
			if (t.matches('input[type="checkbox"][name="wm_food_items[]"]')) {
				const parentElement = t.closest('.wm-food-item');

				if (parentElement.classList.contains('wm-clone-element')) {
					const itemNoClone = form.querySelector(
						`.wm-food-item:not(.wm-clone-element)[data-item="${parentElement.dataset.item}"]`,
					);

					if (itemNoClone) {
						itemNoClone.querySelector(
							'input[type="checkbox"][name="wm_food_items[]"]',
						).checked = false;
					}
				}
				recalcTotals(form);
				toogleElementToOverview(form, t);
				// }
			}
			if (t.matches('input[name="wm_peoples"], input[name="wm_children"]')) {
				recalcTotals(form);
			}
			if (t.matches('input[name="wm_description"]')) {
				const titleWrapper = form.querySelector(
					`.wm-step-overview .wm-step-overview-title`,
				);
				const value = t.value;
				if (value != '') {
					titleWrapper.classList.remove('hide');
					titleWrapper.textContent = value;
				} else {
					titleWrapper.classList.remove('hide');
				}
			}
		});

		form.addEventListener('input', (e) => {
			const t = e.target;
			if (!t) return;
			if (t.matches('input[name="wm_peoples"], input[name="wm_children"]'))
				recalcTotals(form);
		});

		// Initial totals
		recalcTotals(form);

		// Ensure the currently marked active tabs/panels are consistent
		const activeMain = form.querySelector('[data-wm-main-tab].is-active');
		if (activeMain) {
			activateMainTab(form, activeMain.dataset.wmMainTab);
		}

		form.addEventListener('submit', async (e) => {
			e.preventDefault();
			if (hasMenuOnly) return;
			form.classList.remove('min-pp-error');
			document.body.classList.remove('show-error');

			const recalcData = recalcTotals(form, true);

			if (formMode === 'step' && !validateStep(1)) {
				setMessage(
					wrap,
					'error',
					window.WMPlugin.i18n && window.WMPlugin.i18n.required
						? window.WMPlugin.i18n.required
						: 'Popunite sva obavezna polja.',
				);
				return;
			}

			// Simple validation
			const peopleCounts = peopleCount(form);
			if (peopleCounts.adults + peopleCounts.children <= 0) {
				setMessage(wrap, 'error', 'Unesite broj odraslih i/ili dece.');
				return;
			}

			if (recalcData?.minPP > recalcData?.perPerson) {
				form.classList.add('min-pp-error');
				document.body.classList.add('show-error');
				return;
			}

			const fd = new FormData(form);
			fd.append('action', 'wm_submit_form');
			fd.append('nonce', window.WMPlugin.nonce);
			fd.append('type', form.dataset.menutype);

			try {
				const res = await fetch(window.WMPlugin.ajaxUrl, {
					method: 'POST',
					credentials: 'same-origin',
					body: fd,
				});

				const json = await res.json();

				if (json && json.success) {
					let message = window.WMPlugin.i18n.success;
					message =
						(json.data && json.data.message) || window.WMPlugin.i18n.success;
					message = (json.data && json.data.html) || message;

					setMessage(wrap, 'success', message);
					form.reset();

					// After reset, keep first tab active
					const firstMain = form.querySelector('[data-wm-main-tab]');
					if (firstMain) activateMainTab(form, firstMain.dataset.wmMainTab);
					removeStepsClass(form);
					document.body.classList.add('form-succes-submit');
					recalcTotals(form);
				} else {
					setMessage(
						wrap,
						'error',
						(json.data && json.data.message) || window.WMPlugin.i18n.error,
					);
					if (json.data?.code && json.data?.code == 'min_pp_error') {
						form.classList.add('min-pp-error');
						document.body.classList.add('show-error');
					}
				}
			} catch (err) {
				setMessage(wrap, 'error', window.WMPlugin.i18n.error);
			}
		});
	});
})();
